<template>
  <div class="mc-delivery-track-sidebar-detail-item mc-delivery-track-sidebar-detail-item--edit">
    <div class="mc-delivery-track-sidebar-edit-alert">
      <McAlert
        class="mb-2"
        variant="info"
        text="Rentang waktu perjalanan akan diperbarui mengikuti perubahan ini"
        withIcon
        :withGap="false"
        iconPosition="center"
      />
    </div>

    <div class="mc-delivery-track-sidebar-edit-fields">
      <div class="mc-delivery-track-sidebar-edit-field">
        <FormulateInput
          outer-class="mb-0 w-100"
          v-model="form.geofenceIn"
          label="Masuk Geolokasi"
          name="dropGeofenceIn"
          type="date-picker"
          datepickerType="datetime"
          value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
          format="DD MMM YYYY HH:mm"
          append-to-body
          :validation="`bail${isGeofenceInRequired ? '|required' : ''}|geofenceInGtGeofenceOutPickup|geofenceInGtActualPick|geofenceInLtActualDrop|geofenceInNeqActualDrop`"
          validation-behavior="live"
          error-behavior="live"
          :validation-rules="{
            geofenceInGtGeofenceOutPickup,
            geofenceInGtActualPick,
            geofenceInLtActualDrop,
            geofenceInNeqActualDrop,
          }"
          :validation-messages="{
            required: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
            geofenceInGtGeofenceOutPickup: `Tidak boleh kurang dari atau sama dengan keluar geolokasi ambil: ${geofenceOutPickupFormatted}`,
            geofenceInGtActualPick: `Tidak boleh kurang dari atau sama dengan aktual diambil: ${actualPickFormatted}`,
            geofenceInLtActualDrop: 'Tidak boleh lebih dari waktu aktual terkirim',
            geofenceInNeqActualDrop: 'Tidak boleh sama dengan waktu aktual terkirim',
          }"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
        />
      </div>

      <div class="mc-delivery-track-sidebar-edit-field">
        <FormulateInput
          outer-class="mb-0 w-100"
          v-model="form.actualDrop"
          label="Aktual Terkirim"
          name="actualDrop"
          type="date-picker"
          datepickerType="datetime"
          value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
          format="DD MMM YYYY HH:mm"
          append-to-body
          :validation="`bail${isActualDropRequired ? '|required' : ''}|actualDropGtGeofenceIn|actualDropGtGeofenceOutPickup|actualDropGtActualPick|actualDropLtGeofenceOut|actualDropLtEndTime`"
          validation-behavior="live"
          error-behavior="live"
          :validation-rules="{
            actualDropGtGeofenceIn,
            actualDropGtGeofenceOutPickup,
            actualDropGtActualPick,
            actualDropLtGeofenceOut,
            actualDropLtEndTime,
          }"
          :validation-messages="{
            required: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
            actualDropGtGeofenceIn: 'Tidak boleh kurang dari atau sama dengan masuk geolokasi',
            actualDropGtGeofenceOutPickup: `Tidak boleh kurang dari atau sama dengan keluar geolokasi ambil: ${geofenceOutPickupFormatted}`,
            actualDropGtActualPick: `Tidak boleh kurang dari atau sama dengan aktual diambil: ${actualPickFormatted}`,
            actualDropLtGeofenceOut: 'Tidak boleh lebih dari atau sama dengan keluar geolokasi',
            actualDropLtEndTime: isAssignmentEndTimeNow ? 'Tidak boleh lebih dari atau sama dengan waktu saat ini' : `Tidak boleh lebih dari atau sama dengan penugasan selesai: ${assignmentEndTimeFormatted}`,
          }"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
        />
        <p v-if="actualDropTarget" class="mc-delivery-track-sidebar-edit-field-note">
          {{ `(Target: ${actualDropTarget})` }}
        </p>
      </div>

      <div class="mc-delivery-track-sidebar-edit-field">
        <FormulateInput
          outer-class="mb-0 w-100"
          v-model="form.geofenceOut"
          label="Keluar Geolokasi"
          name="dropGeofenceOut"
          type="date-picker"
          datepickerType="datetime"
          value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
          format="DD MMM YYYY HH:mm"
          append-to-body
          :validation="`bail${isGeofenceOutRequired ? '|required' : ''}|geofenceOutGtActualDrop|geofenceOutLtEndTime`"
          validation-behavior="live"
          error-behavior="live"
          :validation-rules="{
            geofenceOutGtActualDrop,
            geofenceOutLtEndTime,
          }"
          :validation-messages="{
            required: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
            geofenceOutGtActualDrop: 'Tidak boleh kurang dari atau sama dengan aktual terkirim',
            geofenceOutLtEndTime: isAssignmentEndTimeNow ? 'Tidak boleh lebih dari atau sama dengan waktu saat ini' : `Tidak boleh lebih dari atau sama dengan penugasan selesai: ${assignmentEndTimeFormatted}`,
          }"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
        />
      </div>
    </div>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert'
import moment from 'moment'

export default {
  components: {
    McAlert,
  },
  props: {
    geofenceIn: {
      type: String,
      default: '',
    },
    actualDrop: {
      type: String,
      default: '',
    },
    actualDropTarget: {
      type: String,
      default: '',
    },
    geofenceOut: {
      type: String,
      default: '',
    },
    geofenceInPickup: {
      type: String,
      default: '',
    },
    actualPick: {
      type: String,
      default: '',
    },
    geofenceOutPickup: {
      type: String,
      default: '',
    },
    delivery: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        geofenceIn: this.normalizeDateValue(this.geofenceIn),
        actualDrop: this.normalizeDateValue(this.actualDrop),
        geofenceOut: this.normalizeDateValue(this.geofenceOut),
      },
    }
  },
  computed: {
    assignmentEndTime() {
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'
      let arrivalOn = null

      if (isTransit) {
        const destinationId = this.delivery?.destination_address?.id
        const transit = this.delivery?.transits?.find((t) => t.destination_address?.id === destinationId)
        arrivalOn = transit?.fleet_task?.actual_arrival_on
      } else {
        arrivalOn = this.delivery?.fleet_task?.actual_arrival_on
      }

      return arrivalOn || moment().toISOString()
    },
    isAssignmentEndTimeNow() {
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'
      let arrivalOn = null

      if (isTransit) {
        const destinationId = this.delivery?.destination_address?.id
        const transit = this.delivery?.transits?.find(
          (t) => t.destination_address?.id === destinationId
        )
        arrivalOn = transit?.fleet_task?.actual_arrival_on
      } else {
        arrivalOn = this.delivery?.fleet_task?.actual_arrival_on
      }

      return !arrivalOn
    },
    assignmentEndTimeFormatted() {
      if (!this.assignmentEndTime) return ''
      return moment(this.assignmentEndTime).locale('id').format('DD MMM YYYY, HH:mm')
    },
    assignmentStartTime() {
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'

      if (isTransit) {
        const destinationId = this.delivery?.destination_address?.id
        const transit = this.delivery?.transits?.find((t) => t.destination_address?.id === destinationId)
        return transit?.fleet_task?.actual_departure_on || null
      }

      return this.delivery?.fleet_task?.actual_departure_on || null
    },
    assignmentStartTimeFormatted() {
      if (!this.assignmentStartTime) return ''
      return moment(this.assignmentStartTime).locale('id').format('DD MMM YYYY, HH:mm')
    },
    geofenceInPickupFormatted() {
      if (!this.geofenceInPickup) return ''
      return moment(this.geofenceInPickup).locale('id').format('DD MMM YYYY, HH:mm')
    },
    actualPickFormatted() {
      if (!this.actualPick) return ''
      return moment(this.actualPick).locale('id').format('DD MMM YYYY, HH:mm')
    },
    geofenceOutPickupFormatted() {
      if (!this.geofenceOutPickup) return ''
      return moment(this.geofenceOutPickup).locale('id').format('DD MMM YYYY, HH:mm')
    },
    isGeofenceInRequired() {
      return !!this.normalizeDateValue(this.geofenceIn)
    },
    isActualDropRequired() {
      return !!this.normalizeDateValue(this.actualDrop)
    },
    isGeofenceOutRequired() {
      return !!this.normalizeDateValue(this.geofenceOut)
    },
  },
  watch: {
    geofenceIn(newVal) {
      this.form.geofenceIn = this.normalizeDateValue(newVal)
    },
    actualDrop(newVal) {
      this.form.actualDrop = this.normalizeDateValue(newVal)
    },
    geofenceOut(newVal) {
      this.form.geofenceOut = this.normalizeDateValue(newVal)
    },
    form: {
      handler(newVal) {
        this.$emit('change', {
          geofenceIn: newVal.geofenceIn || '',
          actualDrop: newVal.actualDrop || '',
          geofenceOut: newVal.geofenceOut || '',
        })
        this.$emit('validation-change', this.getValidationResult())
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getValidationResult() {
      const checks = [
        {
          check: !this.isGeofenceInRequired || !!this.form.geofenceIn,
          message: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
        },
        {
          check: !this.isActualDropRequired || !!this.form.actualDrop,
          message: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
        },
        {
          check: !this.isGeofenceOutRequired || !!this.form.geofenceOut,
          message: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
        },
        {
          check: this.geofenceInGtGeofenceOutPickup({ value: this.form.geofenceIn }),
          message: `Tidak boleh kurang dari atau sama dengan keluar geolokasi ambil: ${this.geofenceOutPickupFormatted}`,
        },
        {
          check: this.geofenceInGtActualPick({ value: this.form.geofenceIn }),
          message: `Tidak boleh kurang dari atau sama dengan aktual diambil: ${this.actualPickFormatted}`,
        },
        {
          check: this.geofenceInLtActualDrop({ value: this.form.geofenceIn }),
          message: 'Tidak boleh lebih dari waktu aktual terkirim',
        },
        {
          check: this.geofenceInNeqActualDrop({ value: this.form.geofenceIn }),
          message: 'Tidak boleh sama dengan waktu aktual terkirim',
        },
        {
          check: this.actualDropGtGeofenceIn({ value: this.form.actualDrop }),
          message: 'Tidak boleh kurang dari atau sama dengan masuk geolokasi ambil',
        },
        {
          check: this.actualDropGtGeofenceOutPickup({ value: this.form.actualDrop }),
          message: `Tidak boleh kurang dari atau sama dengan keluar geolokasi ambil: ${this.geofenceOutPickupFormatted}`,
        },
        {
          check: this.actualDropGtActualPick({ value: this.form.actualDrop }),
          message: `Tidak boleh kurang dari atau sama dengan aktual diambil: ${this.actualPickFormatted}`,
        },
        {
          check: this.actualDropLtGeofenceOut({ value: this.form.actualDrop }),
          message: 'Tidak boleh lebih dari atau sama dengan keluar geolokasi ambil',
        },
        {
          check: this.actualDropLtEndTime({ value: this.form.actualDrop }),
          message: this.isAssignmentEndTimeNow ? 'Tidak boleh lebih dari atau sama dengan waktu saat ini' : `Tidak boleh lebih dari atau sama dengan penugasan selesai: ${this.assignmentEndTimeFormatted}`,
        },
        {
          check: this.geofenceOutGtActualDrop({ value: this.form.geofenceOut }),
          message: 'Tidak boleh kurang dari sama dengan aktual diambil',
        },
        {
          check: this.geofenceOutLtEndTime({ value: this.form.geofenceOut }),
          message: this.isAssignmentEndTimeNow ? 'Tidak boleh lebih dari atau sama dengan waktu saat ini' : `Tidak boleh lebih dari atau sama dengan penugasan selesai: ${this.assignmentEndTimeFormatted}`,
        },
      ]

      const firstFailedCheck = checks.find((item) => !item.check)
      if (firstFailedCheck) {
        return {
          isValid: false,
          message: firstFailedCheck.message,
        }
      }

      return {
        isValid: true,
        message: '',
      }
    },
    parseDateValue(value) {
      const normalized = this.normalizeDateValue(value)
      if (!normalized) return null

      const parsed = moment(normalized, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true)
      return parsed.isValid() ? parsed : null
    },
    normalizeDateValue(value) {
      if (!value || value === '-') return ''

      const isoFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ'
      if (moment(value, isoFormat, true).isValid()) return value

      const sanitizedValue = String(value).replace(/\s+(WIB|WITA|WIT|UTC[+-]\d{1,2})$/i, '')

      const parsedId = moment(sanitizedValue, ['DD MMM YYYY, HH:mm', 'DD MMM YYYY HH:mm'], 'id', true)
      if (parsedId.isValid()) return parsedId.format(isoFormat)

      const parsedEn = moment(sanitizedValue, ['DD MMM YYYY, HH:mm', 'DD MMM YYYY HH:mm'], 'en', true)
      if (parsedEn.isValid()) return parsedEn.format(isoFormat)

      const parsedIso = moment(sanitizedValue, moment.ISO_8601, true)
      if (parsedIso.isValid()) return parsedIso.format(isoFormat)

      const fallbackParsed = moment(sanitizedValue)
      return fallbackParsed.isValid() ? fallbackParsed.format(isoFormat) : ''
    },
    geofenceInGtGeofenceOutPickup({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const geofenceOutPickup = this.parseDateValue(this.geofenceOutPickup)
      if (!geofenceIn || !geofenceOutPickup) return true
      return geofenceIn.isAfter(geofenceOutPickup, 'second')
    },
    geofenceInGtActualPick({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const geofenceOutPickup = this.parseDateValue(this.geofenceOutPickup)
      const actualPick = this.parseDateValue(this.actualPick)
      if (!geofenceIn || geofenceOutPickup || !actualPick) return true
      return geofenceIn.isAfter(actualPick, 'second')
    },
    geofenceInLtActualDrop({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const actualDrop = this.parseDateValue(this.form.actualDrop)
      if (!geofenceIn || !actualDrop) return true
      if (geofenceIn.isSame(actualDrop, 'second')) return true
      return geofenceIn.isBefore(actualDrop, 'second')
    },
    geofenceInNeqActualDrop({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const actualDrop = this.parseDateValue(this.form.actualDrop)
      if (!geofenceIn || !actualDrop) return true
      return !geofenceIn.isSame(actualDrop, 'second')
    },
    actualDropGtGeofenceIn({ value }) {
      const actualDrop = this.parseDateValue(value)
      const geofenceIn = this.parseDateValue(this.form.geofenceIn)
      if (!actualDrop || !geofenceIn) return true
      if (actualDrop.isSame(geofenceIn, 'second')) return true
      return actualDrop.isAfter(geofenceIn, 'second')
    },
    actualDropGtGeofenceOutPickup({ value }) {
      const actualDrop = this.parseDateValue(value)
      const geofenceIn = this.parseDateValue(this.form.geofenceIn)
      const geofenceOutPickup = this.parseDateValue(this.geofenceOutPickup)
      if (!actualDrop || geofenceIn || !geofenceOutPickup) return true
      return actualDrop.isAfter(geofenceOutPickup, 'second')
    },
    actualDropGtActualPick({ value }) {
      const actualDrop = this.parseDateValue(value)
      const geofenceIn = this.parseDateValue(this.form.geofenceIn)
      const geofenceOutPickup = this.parseDateValue(this.geofenceOutPickup)
      const actualPick = this.parseDateValue(this.actualPick)
      if (!actualDrop || geofenceIn || geofenceOutPickup || !actualPick) return true
      return actualDrop.isAfter(actualPick, 'second')
    },
    actualDropLtGeofenceOut({ value }) {
      const actualDrop = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)
      if (!actualDrop || !geofenceOut) return true
      return actualDrop.isBefore(geofenceOut, 'second')
    },
    actualDropLtEndTime({ value }) {
      const actualDrop = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)
      if (!actualDrop || geofenceOut) return true
      const endTime = this.assignmentEndTime ? moment(this.assignmentEndTime) : null
      if (!endTime) return true
      return actualDrop.isBefore(endTime, 'second')
    },
    geofenceOutGtActualDrop({ value }) {
      const geofenceOut = this.parseDateValue(value)
      const actualDrop = this.parseDateValue(this.form.actualDrop)
      if (!geofenceOut || !actualDrop) return true
      return geofenceOut.isAfter(actualDrop, 'second')
    },
    geofenceOutLtEndTime({ value }) {
      const geofenceOut = this.parseDateValue(value)
      const endTime = this.assignmentEndTime ? moment(this.assignmentEndTime) : null
      if (!geofenceOut || !endTime) return true
      return geofenceOut.isBefore(endTime, 'second')
    },
  },
}
</script>

<style scoped lang="scss">
.mc-delivery-track-sidebar-edit-field {
  :deep(ul.formulate-input-errors) {
    list-style: none;
    margin: 4px 0 0;
    padding: 0;
    color: #ea4a4a;
    font-size: 12px;
    font-style: italic;
  }

  :deep(ul.formulate-input-errors li.formulate-input-error::before) {
    content: '';
    display: none;
  }

  :deep([data-is-showing-errors='true'] .mx-input),
  :deep([data-is-showing-errors='true'] .mx-datepicker input) {
    border-color: #ea4a4a !important;
  }
}
</style>
